import React from "react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";

export default function Terms() {
  return (
    <div data-testid="page-terms">
      <PageHeader eyebrow="Legal" title="Terms &" accent="Conditions" />
      <section className="max-w-3xl mx-auto px-4 md:px-8 pb-20 prose prose-invert text-white/75 leading-relaxed">
        <Reveal>
          <p>Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

          <h2 className="text-2xl font-extrabold mt-8">1. Use of website</h2>
          <p>This website is operated by Taste of Egg, a registered Australian food truck business based in Clayton, Victoria. By accessing the site you agree to these Terms.</p>

          <h2 className="text-2xl font-extrabold mt-8">2. Pricing & menu</h2>
          <p>Menu items and prices listed online are indicative and may vary at the truck due to seasonal availability. Final prices at the point of sale are authoritative.</p>

          <h2 className="text-2xl font-extrabold mt-8">3. Allergens</h2>
          <p>All dishes contain eggs. Some dishes contain dairy, gluten, nuts or chilli. Please inform our staff of any allergies before ordering. We cannot guarantee a fully allergen-free environment.</p>

          <h2 className="text-2xl font-extrabold mt-8">4. Catering & bookings</h2>
          <p>Catering bookings require a non-refundable deposit. Cancellation within 48 hours of the event will forfeit the deposit. Final headcount must be confirmed 24 hours prior.</p>

          <h2 className="text-2xl font-extrabold mt-8">5. Intellectual property</h2>
          <p>All content (logo, photography, copy) is the property of Taste of Egg unless otherwise noted. Do not reproduce without written permission.</p>

          <h2 className="text-2xl font-extrabold mt-8">6. Contact</h2>
          <p>Questions about these terms? Email info@tasteofegg.com.au or call 0434 508 712.</p>
        </Reveal>
      </section>
    </div>
  );
}
